import { Component, computed, ElementRef, HostListener, OnInit, signal, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { MainMenuComponent } from '../main-menu/main-menu.component';
import { AppLayout } from '../shared/models/app.model';
import { AuthUser } from '../shared/models/user.model';
import { BrowserUtils } from '../shared/services/browser-utils';
import { ConfirmedActionsService } from '../shared/services/confirmed-actions.service';
import { DatadogService } from '../shared/services/datadog.service';
import { FreshChatService } from '../shared/services/fresh-chat.service';
import { LocalStorageService } from '../shared/services/localStorage.service';
import { UsersService } from '../shared/services/users.service';

@Component({
  standalone: false,
  selector: 'app-component',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild(MainMenuComponent, { static: false }) mainMenu: MainMenuComponent;

  loading = false;
  user: AuthUser;
  lastActivePingInterval = null;
  today = new Date();
  currentYear: number = new Date().getFullYear();
  showCopyrightText = false;

  // signals
  readonly layout = signal<AppLayout>('default');
  readonly isPublicLayout = computed(() => this.layout() === 'public');

  constructor(
    public elementRef: ElementRef,
    public storage: LocalStorageService,
    public router: Router,
    private route: ActivatedRoute,
    public userService: UsersService,
    vc: ViewContainerRef,
    confirmedActionsService: ConfirmedActionsService,
    dg: DatadogService
  ) {
    confirmedActionsService.setRootViewContainerRef(vc);
    dg.init();
  }

  ngOnInit() {
    BrowserUtils.initPlugins();
    // this.updateLayoutFromRoute();
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart || event instanceof NavigationEnd || event instanceof ActivationEnd))
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          this.showCopyrightText = false;
        }

        if (event instanceof ActivationEnd) {
          const layout = event.snapshot.data?.['layout'];

          this.layout.set(layout || 'default');
        }

        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            this.showCopyrightText = true;
          }, 500);
        }
      });
    this.userService.authUpdates.subscribe((user: AuthUser) => {
      this.user = user;
      FreshChatService.setUser(user);
      // Call last-active endpoint every 5 minutes ...
      this.resetPings();
      this.lastActivePingInterval = setInterval(
        () => {
          // TODO: Remove this note later ...
          // authUser is the user that is being impersonated ...
          // this.user or user is the admin one ...
          if (this.userService.authUser && !this.userService.authUser.impersonated) {
            this.userService.ping();
          }
        },
        5 * 60 * 1000
      );
      this.userService.ping();
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler() {
    BrowserUtils.isUnload = true;
  }

  logout() {
    this.loading = true;
    this.userService.logout(['/login'], ['/users']).then(url => {
      this.resetPings();
      this.router.navigate(url).finally(() => (this.loading = false));
    });
  }

  private resetPings() {
    if (this.lastActivePingInterval !== null) {
      clearInterval(this.lastActivePingInterval);
      this.lastActivePingInterval = null;
    }
  }
}
